import { render, staticRenderFns } from "./Assignees.vue?vue&type=template&id=43b305a8&scoped=true&"
import script from "./Assignees.vue?vue&type=script&lang=js&"
export * from "./Assignees.vue?vue&type=script&lang=js&"
import style0 from "./Assignees.vue?vue&type=style&index=0&id=43b305a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b305a8",
  null
  
)

export default component.exports